import React, {useCallback, useEffect, useRef, useState} from 'react';
import FileUpload from '../../resources/icon/file-upload.png'
import UploadHere from '../../resources/icon/upload.png'
import Forbidden from '../../resources/icon/forbidden.png'
import EXCEL from '../../resources/icon/excel-icon.png'
import PPTX from '../../resources/icon/ppt-icon.png'
import PDF from '../../resources/icon/pdf-icon.png'
import Word from '../../resources/icon/word-icon.png'
import Doc from '../../resources/icon/documnet-icon.png'
import {deleteImagesAndFiles, getFile, getImagesAndFiles, uploadImagesAndFiles} from "../../api/file/FileService";
import {useDispatch} from "react-redux";
import {apiLoading} from "../../redux/slice/apiSlice";
import HWP from "../../resources/icon/hwp-icon.png";
import IMG from "../../resources/icon/img-upload.png";
import ZIP from "../../resources/icon/zip-icon.png";
import AttachmentFileList from "./AttachmentFileList";
import AttachmentListUploader from "./AttachmentListUploader";

/**
 * `파일업로더 `파일
 * */

function UpdateFile({tableInfo, isMobileUsed, readOnly = false, displayMode = "thumbnail", variant}) {
    const isListMode = displayMode === "list";
    const [file, setFile] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);

    const dispatch = useDispatch();

    async function getFileData() {
        try {
            dispatch(apiLoading(true));
            const response = await getImagesAndFiles(tableInfo.tableName, tableInfo.joinKey, "FILE");
            if(response.status===200){
                dispatch(apiLoading(false));
                setFile(response.data);
                setPreviewImages(response.data);
            } else {
                dispatch(apiLoading(false));
            }
        }catch (e){

        }
    }

    useEffect(()=>{
        getFileData();
    }, [tableInfo.joinKey])

    const imageMap = {
        'PDF': PDF,
        'PPTX': PPTX,
        'POWERPOINT': PPTX,
        'WORD':Word ,
        'DOCX' : Word,
        'XLS' : EXCEL,
        'XLSX' : EXCEL,
        'HWP' : HWP,
        'JPG' : IMG,
        'JPNG' : IMG,
        'TIFF': IMG,
        'TIF': IMG,
        'PNG' : IMG,
        'ZIP' : ZIP,
    };

    const acceptedFileTypes = [
        'application/vnd.hancom.hwp',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/pdf',
        'image/tiff',
        'image/x-tiff',
        'application/tiff',
        'text/plain',
        'image/jpeg', // JPG, JPEG
        'image/png',  // PNG
        'application/x-hwp', // HWP 파일
        'application/haansofthwp', // HWP 파일
        'application/haansoft-hwp', // HWP 파일
        'application/octet-stream', // HWP 파일
        'application/zip', // ZIP 파일
        'application/x-zip-compressed', // ZIP 파일
        'multipart/x-zip', // ZIP 파일
        'application/octet-stream', // ZIP 파일
    ];
    // 드래그 중일때와 아닐때의 스타일을 구분하기 위한 state 변수
    const [isDragging, setIsDragging] = useState(false);
    const [dragIn, setDragIn]=useState(false);
    // 각 선택했던 파일들의 고유값 id
    const fileId = useRef(0);
    // 드래그 이벤트를 감지하는 ref 참조변수 (label 태그에 들어갈 예정)
    const dragRef = useRef(null);

    const fileUploadOrReturn = async (e) => {
        let selectFiles = [];
        if (tableInfo) {
            if (window.confirm("업로드하시겠습니까?")) {
                await uploadImagesAndFiles("", e.type === "drop" ? e.dataTransfer.files : e.target.files, tableInfo);
                getFileData();
            } else {
                return selectFiles;
            }
        } else {
            if (e.type === "drop") {
                selectFiles = Array.from(e.dataTransfer.files);
            } else {
                selectFiles = Array.from(e.target.files);
            }
        }

        return selectFiles;
    }

    const onChangeFiles = useCallback(async (e) => {
        let tempFiles = file.slice();
        const newPreviewImages = previewImages.slice();
        let selectFiles = await fileUploadOrReturn(e);

        for (const file of selectFiles) {
            const id = fileId.current++;
            if (acceptedFileTypes.includes(file.type)) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const previewImage = event.target.result;
                    tempFiles.push({
                        id,
                        object: file,
                        previewImage,
                    });
                    setFile(tempFiles);
                    newPreviewImages.push(previewImage); // newPreviewImages에 새로운 미리보기 이미지를 추가합니다.
                    setPreviewImages(newPreviewImages);

                };
                reader.readAsDataURL(file);
            } else {
                alert('지원하지 않는 파일 형식입니다.\n형식 : '+file.type);
            }
        }
    }, []);

    const handleDeleteFile = async (item) => {
        const deleteId = item?.id;
        if (!deleteId || !tableInfo) return;

        if (window.confirm("삭제하시겠습니까?")) {
            const newPreviewImages = previewImages.filter((image) => image.id !== deleteId);
            setPreviewImages(newPreviewImages);

            const newFiles = file.filter((f) => f.id !== deleteId);
            setFile(newFiles);

            await deleteImagesAndFiles(deleteId, tableInfo.tableName, tableInfo.joinKey);
        }
    };
    const handleFileInputChange = (e) => {
        if (isListMode || !isDragging) {
            onChangeFiles(e);
        }
    };
    const handleDragIn = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        setDragIn(true);
    }, []);

    const handleDragOut = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        setDragIn(false);
    }, []);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer?.files.length > 0) {
            setIsDragging(true);
        } else {
            setIsDragging(false);
        }
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer?.files.length > 0) {
            setIsDragging(false);
            setDragIn(false);
            onChangeFiles(e);
        }
    }, [onChangeFiles]);



    const initDragEvents = useCallback(() => {
        if (dragRef.current !== null) {
            dragRef.current.addEventListener("dragenter", handleDragIn);
            dragRef.current.addEventListener("dragleave", handleDragOut);
            dragRef.current.addEventListener("dragover", handleDragOver);
            dragRef.current.addEventListener("drop", handleDrop);
        }
    }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

    const resetDragEvents = useCallback(() => {
        // 앞서 말했던 4개의 이벤트에 Listener를 삭제합니다. (언마운트 될때)
        if (dragRef.current !== null) {
            dragRef.current.removeEventListener("dragenter", handleDragIn);
            dragRef.current.removeEventListener("dragleave", handleDragOut);
            dragRef.current.removeEventListener("dragover", handleDragOver);
            dragRef.current.removeEventListener("drop", handleDrop);
        }
    }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

    useEffect(() => {
        if (isListMode) return undefined;
        initDragEvents();
        return () => resetDragEvents();
    }, [isListMode, initDragEvents, resetDragEvents]);




    if (isListMode) {
        const uploaderClass = variant === "kv" ? "attch-uploader--kv-inline" : "";
        return (
            <div
                className={`w-full relative z-index-1 ${
                    isMobileUsed ?? "mobile-hidden updateFile"
                } attachment-uploader--list${variant === "kv" ? " attachment-uploader--kv" : ""}`}
            >
                <AttachmentListUploader
                    readOnly={readOnly}
                    className={uploaderClass}
                    inputId="file_doc"
                    emptyLabel="첨부된 파일이 없습니다."
                    onInputChange={handleFileInputChange}
                    hasFiles={previewImages.length > 0}
                    fileList={
                        <AttachmentFileList
                            items={previewImages}
                            readOnly={readOnly}
                            onRemove={handleDeleteFile}
                            onOpen={(item) => getFile(item)}
                        />
                    }
                />
            </div>
        );
    }

    const renderFileArea = () => {
        if (dragIn) {
            return (
                <>
                    <img src={UploadHere} className="w-[50px] inline-block mt-4 mb-4 drag-drop-img " alt="" />
                    <span className=" c-gray drag-drop-txt">여기에 놓으세요</span>
                </>
            );
        }

        return (
            <>
                {previewImages &&
                    previewImages.map((previewImage, index) => {
                        const fileName = previewImage.originalName;
                        const ext = previewImage.ext.toUpperCase();
                        return (
                            <React.Fragment key={index}>
                                <div className="uploaded-img  mt-[10px] print-hidden">
                                    {!readOnly && (
                                        <div
                                            className="delete-image"
                                            onClick={() => handleDeleteFile(previewImage, index)}
                                        >
                                            <img src={Forbidden} alt="" />
                                        </div>
                                    )}

                                    <>
                                        <img
                                            src={imageMap[ext] ? imageMap[ext] : Doc}
                                            alt=""
                                            className="w-[50px] uploaded-file"
                                            onClick={() => getFile(previewImage)}
                                        />
                                        <span className="text-nowrap">
                                            {fileName.length > 11
                                                ? fileName.substring(0, 7) + "..."
                                                : fileName}
                                        </span>
                                    </>
                                </div>
                                <div className={"print-show p-[5px]"}>{fileName}</div>
                            </React.Fragment>
                        );
                    })}
                {previewImages[0] || readOnly ? (
                    ""
                ) : (
                    <>
                        <img
                            src={FileUpload}
                            className="w-[50px] inline-block mt-4 mb-4 drag-drop-img print-hidden mobile-hidden"
                            alt=""
                        />
                        <span className="c-gray drag-drop-txt print-hidden mobile-hidden">
                            파일을 끌어서 놓으세요
                        </span>
                    </>
                )}
            </>
        );
    };

    return (
        <div className={`w-full relative z-index-1 ${isMobileUsed ?? "mobile-hidden updateFile"}`}>
            <div
                ref={dragRef}
                className={`b-gray upload-h ${isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}`}
            >
                {renderFileArea()}
            </div>
            {!readOnly && (
            <div className="py-3 bg-basic h-[40px] print-hidden">
                <label  className="file-from-my px-6 py-1 b-gray bg-white item-center"
                        htmlFor={"file_doc"}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 inline-block mr-2" >
                        <path
                            d="M9.25 13.25a.75.75 0 0 0 1.5 0V4.636l2.955 3.129a.75.75 0 0 0 1.09-1.03l-4.25-4.5a.75.75 0 0 0-1.09 0l-4.25 4.5a.75.75 0 1 0 1.09 1.03L9.25 4.636v8.614Z"/>
                        <path
                            d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z"/>
                    </svg>
                    <span className={'line-h-22'}>내 PC에서 파일 찾기</span>
                </label>
                <input
                    className="hidden"
                    id={"file_doc"}
                    type={"file"}
                    multiple={true}
                    onChange={handleFileInputChange}
                />

            </div>
            )}
        </div>
    );
}

export default UpdateFile;
